/* global _tfa */
import createAdapter from './createAdapter'
export const taboola = createAdapter(() => !!window._tfa, {
  page() {
    _tfa.push({ notify: 'event', name: 'page_view', id: 1157532 })
  },
})
